<div class="body">
        <app-header-no-menu></app-header-no-menu>

    <div class="content">
        <router-outlet></router-outlet>
    </div>
</div>

<app-pop-up-politicas></app-pop-up-politicas>